export default function Background({ children, variant, position }) {
  const variants = {
    bgsec1: { backgroundImage: `url(${window.localhost}/img/bgsec1.jpg)` },
    bgsec2: { backgroundImage: `url(${window.localhost}/img/bgsec2.jpg)` },
    bgsec3: { backgroundImage: `url(${window.localhost}/img/bgsec3.jpg)` },
    bgsec4: { backgroundImage: `url(${window.localhost}/img/bgsec4.jpg)` },
    bgsec5: { backgroundImage: `url(${window.localhost}/img/bgsec5.jpg)` },
    bgsec6: { backgroundImage: `url(${window.localhost}/img/bgsec6.jpg)` },
    bgsec7: { backgroundImage: `url(${window.localhost}/img/bgsec7.jpg)` },
    bgsec8: { backgroundImage: `url(${window.localhost}/img/bgsec8.jpg)` },
  };
  const pickedVariant = variant ? variants[variant] : {};

  const positions = {
    bottom: "bg-bottom",
    top: "bg-top",
  };
  const pickedPosition = position ? positions[position] : "";

  return (
    <div
      className={`bg-w100 bg-no-repeat ${pickedPosition}`}
      style={pickedVariant}
    >
      {children}
    </div>
  );
}
